module.exports = __webpack_public_path__ + "static/media/10.74290021.png";